import React from 'react';
import './Navbar.scss';
import logo from './../../assets/mishqah-logo.png';
import {Link} from 'react-router-dom';

const Navbar = () => {

    const navbarItems = [
        {
            name: 'Home',
            path: '/',
        },
        {
            name: 'About Us',
            path: '/about',
        },
        {
            name: 'Services Offered',
            path: '/singleservice',
        },
        {
            name: 'Contact Us',
            path: '/contact',
        }
    ];

    return (
        <header className='main-nav' role="banner">
            <div className="container">
                <nav className="navbar navbar-expand-lg" role="navigation" aria-label="Main navigation">
                    <div className="container-fluid">
                        {/* Logo */}
                        <Link className="navbar-brand d-flex align-items-center" to="/" aria-label="Dr Mishqah Dollie Dental Practice - Home">
                            <div className="logo-container">
                                <img src={logo} alt="Dr Mishqah Dollie Dental Practice Logo" />
                            </div>
                            <span className="doctor-name">Dr Mishqah Dollie</span>
                        </Link>
                        <button 
                            className="navbar-toggler" 
                            type="button" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#navbarSupportedContent" 
                            aria-controls="navbarSupportedContent" 
                            aria-expanded="false" 
                            aria-label="Toggle navigation menu">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            {/* Navbar Link */}
                            <ul className="navbar-nav m-auto mb-2 mb-lg-0" role="menubar">
                               { 
                                navbarItems.map((navSingle, index) =>
                                    <li className="nav-item" key={index} role="none">
                                        <Link 
                                            className="nav-link" 
                                            to={navSingle.path}
                                            role="menuitem"
                                            aria-label={`Navigate to ${navSingle.name} page`}>
                                            {navSingle.name}
                                        </Link>
                                    </li>
                                    ) 
                                }
                            </ul>
                            
                            {/* Navbar Button */}
                            <div className="theme-btn" style={{display: 'inline-block', marginRight: '8px'}}>
                                <a href="https://www.recomed.co.za/dentist/cape-town/mishqah-dollie/7579/7349/" 
                                   target="_blank" 
                                   rel="noopener noreferrer"
                                   aria-label="Book an appointment with Dr Mishqah Dollie in Ottery, Cape Town">
                                    Book appointment
                                </a>
                            </div>
                            <div className="theme-btn review-btn" style={{display: 'inline-block'}}>
                                <a href="https://www.google.com/search?sca_esv=a56679814246b468&rlz=1C1GCEU_enZA923ZA923&sxsrf=AE3TifMS9Fjn-AhqcmcYTGNjiFUyfhkNlA:1750883730935&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-ExYl9rvxnlt7NdxU1lbF7HDBDmnpCf9vEGuJgEPSHg0emLaLN3_Zb9V4hMnYOsoqWH6vnvKV39sE8H0QIkhf0to1BezVMxAgK7pd9gV7XKn22ZOJ3w%3D%3D&q=Dr+Mishqah+Dollie+Reviews&sa=X&ved=2ahUKEwiQ6syWto2OAxWpXKQEHdcWMaQQ0bkNegQIJRAE&biw=1536&bih=695&dpr=1.25" 
                                   target="_blank" 
                                   rel="noopener noreferrer"
                                   aria-label="Leave a Google Review for Dr Mishqah Dollie">
                                    Leave a Review
                                </a>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
            <div className="navbar-separator"></div>
        </header>
    );
};

export default Navbar;